// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3gXlK","col":"styles_col__w5yNL"};